import FormattedMessage from 'I18n/components/FormattedMessage';
import TeamSelectHelpMessage from 'automation-ui-action-features/users-and-teams/TeamSelectHelpMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const convertToAssignableTeamOption = teamObject => {
  const {
    name,
    id,
    assignableUsersCount,
    deactivatedUsersCount
  } = teamObject;
  return {
    text: name || '',
    value: id,
    help: /*#__PURE__*/_jsx(TeamSelectHelpMessage, {
      team: teamObject
    }),
    disabled: assignableUsersCount === 0 || assignableUsersCount === deactivatedUsersCount
  };
};
export const toTeamOptions = (teams = []) => {
  return teams.map(({
    id,
    name,
    userIds
  }) => ({
    text: name || '',
    value: id,
    help: Array.isArray(userIds) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.users-and-teams.teams-select.help.members",
      options: {
        count: userIds.length
      }
    })
  }));
};